import { render } from "./TagServices.vue?vue&type=template&id=17b736f6&scoped=true"
import script from "./TagServices.vue?vue&type=script&lang=js"
export * from "./TagServices.vue?vue&type=script&lang=js"

import "./TagServices.vue?vue&type=style&index=0&id=17b736f6&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b736f6"]])

export default __exports__